import { makeAutoObservable } from "mobx"

export default class DraftInfluencer {

  constructor(draftInfluencer = {}) {
    this.id = draftInfluencer.id
    this.full_name = draftInfluencer.full_name
    this.username = ''
    this.avatar = ''
    this.email = draftInfluencer.email
    this.platforms = []
    this.selectedPlatform = ''
    this.isExpanded = false

    makeAutoObservable(this)
  }

  toggleExpanded() {
    this.isExpanded = !this.isExpanded
  }
}
